var map = {
	"./menu-ico/dashboard.svg": 78370,
	"./menu-ico/device.svg": 40936,
	"./menu-ico/flow.svg": 36894,
	"./menu-ico/global.svg": 43819,
	"./menu-ico/gps.svg": 37098,
	"./menu-ico/msg.svg": 31873,
	"./menu-ico/openapi.svg": 89502,
	"./menu-ico/order.svg": 29514,
	"./menu-ico/production.svg": 23663,
	"./menu-ico/rule.svg": 99984,
	"./menu-ico/selected/dashboard.svg": 13300,
	"./menu-ico/selected/device.svg": 58886,
	"./menu-ico/selected/flow.svg": 4008,
	"./menu-ico/selected/global.svg": 98293,
	"./menu-ico/selected/gps.svg": 75828,
	"./menu-ico/selected/msg.svg": 32683,
	"./menu-ico/selected/openapi.svg": 61368,
	"./menu-ico/selected/order.svg": 83800,
	"./menu-ico/selected/production.svg": 54153,
	"./menu-ico/selected/rule.svg": 28250,
	"./menu-ico/selected/task.svg": 87983,
	"./menu-ico/selected/warning.svg": 61196,
	"./menu-ico/selected/webapp.svg": 13335,
	"./menu-ico/task.svg": 59785,
	"./menu-ico/warning.svg": 80422,
	"./menu-ico/webapp.svg": 44105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20911;